import {Swiper, SwiperSlide} from 'swiper';
import { Navigation, Pagination, A11y, Keyboard } from 'swiper/modules';

document.addEventListener("DOMContentLoaded", function(event) {

	const blogSwiperElements = document.querySelectorAll(".blogSwiper");

	if (blogSwiperElements.length > 0) {

		var slidesPerView = document.querySelector(".blogSwiper").closest(".blog-swiper-attr").getAttribute('data-slide');
		var autoplay = document.querySelector(".blogSwiper").closest(".blog-swiper-attr").getAttribute('data-autoplay'); 
		var loop = document.querySelector(".blogSwiper").closest(".blog-swiper-attr").getAttribute('data-loop');
		var speed = document.querySelector(".blogSwiper").closest(".blog-swiper-attr").getAttribute('data-speed');
		var navigation = document.querySelector(".blogSwiper").closest(".blog-swiper-attr").getAttribute('data-navigation');

		var navigation_obj = {};
		if( navigation ){
			navigation_obj = {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			}
		}else{
			var element = document.getElementsByClassName('swiper-button-next');
			if (element.length > 0) {
			var elementToRemove = element[0];
			elementToRemove.parentNode.removeChild(elementToRemove);
			}

			element = document.getElementsByClassName('swiper-button-prev');
			if (element.length > 0) {
			var elementToRemove = element[0];
			elementToRemove.parentNode.removeChild(elementToRemove);
			}
		}

		console.log(autoplay);
		const swiper = new Swiper(".blogSwiper", {
			modules: [Navigation, Pagination, A11y, Keyboard], 
			slidesPerView: ( slidesPerView ? slidesPerView : 2 ),
			spaceBetween: 24, 
			loop: ( loop ? loop : true ),
			speed: ( speed ? speed : 2000 ),
			autoplay: {
				delay: 2500,
				disableOnInteraction: false,
			  },

			navigation: navigation_obj,
			autoHeight: true,
			mousewheel: true,
			keyboard: {
				enabled: true,
			},
			breakpoints: {
				100: {	
				  slidesPerView: 1,
				},
				768: {	
					slidesPerView: 2,
				},
				1024: {	
					slidesPerView: ( slidesPerView ? slidesPerView : 2 ),
				},
			}
		});
	}
});

